import { getCurrentInstance, ref, readonly } from "vue";


/**
 * Retrieves the current route's path as a read-only ref.
 * The method utilizes the Vue instance's global properties to access the current route.
 *
 * @return {Readonly<Ref<string>>} A readonly ref containing the current route's path.
 */
export function useCurrentRoute() {
  const currentRoute = ref("");

  const instance = getCurrentInstance();
  currentRoute.value = instance?.appContext.config.globalProperties.$route.path;

  return readonly(currentRoute);
}
